import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <p className="text-xs uppercase tracking-[0.25em] text-foreground/50 font-sans">
    {children}
  </p>
);

export const PhotoFrame = ({ caption, note, testId, aspect = "aspect-[4/3]" }) => (
  <figure data-testid={testId}>
    <div
      className={`${aspect} w-full border border-dashed border-foreground/25 bg-muted/50 flex items-center justify-center`}
    >
      <span className="text-[10px] uppercase tracking-[0.3em] text-foreground/35 text-center px-8 leading-relaxed">
        {note}
      </span>
    </div>
    {caption && (
      <figcaption className="mt-4 text-[10px] uppercase tracking-[0.3em] text-foreground/40">
        {caption}
      </figcaption>
    )}
  </figure>
);
